import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49803696"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium leading-6 text-gray-900"
}, "Email Adresse", -1))
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = {
  key: 0,
  class: "error ion-padding"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-sm font-medium leading-6 text-gray-900"
}, "Passwort", -1))
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = {
  key: 0,
  class: "error ion-padding"
}
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = { class: "text-sm leading-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "flex w-full h-11 items-center justify-center rounded-md bg-gr-primary px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-gr-primary3 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
  }, "Anmelden")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.login && $setup.login(...args)), ["prevent"])),
      class: "space-y-6",
      action: "#",
      method: "POST"
    }, [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            id: "email",
            name: "email",
            type: "email",
            autocomplete: "email",
            tabindex: "1",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.loginData.email) = $event)),
            placeholder: "E-Mail",
            required: "required",
            class: "dark:text-white block w-full ps-3 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          }, null, 512), [
            [_vModelText, $setup.loginData.email]
          ])
        ]),
        ($setup.emailError)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($setup.emailError), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            id: "password",
            name: "password",
            type: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.loginData.password) = $event)),
            placeholder: "Passwort",
            tabindex: "2",
            autocomplete: "current-password",
            required: "required",
            class: "block dark:text-white w-full ps-3 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          }, null, 512), [
            [_vModelText, $setup.loginData.password]
          ])
        ]),
        ($setup.passwordError)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($setup.passwordError), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, {
            class: "font-semibold text-gray-700 hover:text-black w-full",
            to: "/forgotPassword"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.forgotPassword), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_9
    ], 32)
  ]))
}